import { BootstrapData, ViewerHandlers } from '../../types'
import type { IModelsAPI } from '@wix/thunderbolt-symbols'

const clientConfig = {
	onRemoteChange: (cb: (name: string, value: any) => void) => {
		self.onmessage = ({ data: message }) => {
			if (message.type === 'updateRemote') {
				const { name, value } = message
				cb(name, value)
			}
		}
	},
	updateRemote: (name: string, value: any) => {
		postMessage({ type: 'updateRemote', name, value })
	},
}

const serverConfig = (viewerHandlers: ViewerHandlers) => {
	return {
		onRemoteChange: () => {}, // platform doesn't consume updates in ssr
		updateRemote: (name: string, value: any) => viewerHandlers.ssr.updateRemote(name, value),
	}
}

export default (_: IModelsAPI, bootstrapData: BootstrapData, viewerHandlers: ViewerHandlers) => {
	const {
		platformEnvData: {
			window: { isSSR },
		},
	} = bootstrapData

	return isSSR ? serverConfig(viewerHandlers) : clientConfig
}
